export default "__VITE_ASSET__C80e76Yi__"